import { useState, useEffect } from "react";
import aboutImage from "../assets/home-images/about.png";
import TableOfContents from "../components/TableOfContents";
import { ArrowLeftIcon } from "lucide-react";
import floorplanImage from "../assets/about/floorplan.jpg";
import MarkdownRenderer from "../components/MarkdownRenderer";

const images = {
	floorplanImage,
};

const ABOUT_ACCENT = "#113b1b";

const About = () => {
	const [markdownContent, setMarkdownContent] = useState("");

	useEffect(() => {
		window.scrollTo(0, 0);

		fetch("/content/about.md")
			.then((response) => response.text())
			.then((text) => setMarkdownContent(text))
			.catch((error) => {
				console.error("Error loading markdown:", error);
				// Fallback content
				setMarkdownContent("Content loading failed. Please refresh the page.");
			});
	}, []);

	return (
		<div className="relative grid w-full min-h-screen bg-[#F5F1E5] grid-cols-1 lg:grid-cols-[200px_1fr_200px] grid-rows-[30px_1fr_30px]">
			{/* Mobile fixed top bar with Back button */}
			<div className="fixed inset-x-0 top-0 z-40 lg:hidden bg-[#F5F1E5] h-14">
				<div
					className="absolute bottom-0 left-0 right-0 h-[2px]"
					style={{
						background: `linear-gradient(to bottom, #FFFFFF 0%, #FFFFFF 50%, #BFA99F 50%, #BFA99F 100%)`,
					}}
				/>
				<div className="h-full flex items-center px-4">
					<button
						className="flex items-center font-semibold space-x-2 text-white text-sm px-2 py-1 rounded-full bg-[#113b1b] shadow"
						onClick={() => window.history.back()}
					>
						<ArrowLeftIcon className="w-3 h-3 transition-transform duration-200" />
						<span>Back</span>
					</button>
				</div>
			</div>
			{/* Top container (was top border line) */}
			<div className="relative hidden lg:block col-span-3 row-start-1 h-[30px] pointer-events-none z-20">
				<div
					className="absolute bottom-0 left-0 right-0 h-[2px] z-20"
					style={{
						background: `linear-gradient(to bottom, #FFFFFF 0%, #FFFFFF 50%, #BFA99F 50%, #BFA99F 100%)`,
					}}
				/>
			</div>

			{/* Vertical lines overlay spanning both rows */}
			<div className="pointer-events-none absolute inset-0 z-10 hidden lg:block">
				<div
					className="absolute top-0 bottom-0 left-[200px] w-[2px]"
					style={{
						background: `linear-gradient(to right, #BFA99F 0%, #BFA99F 50%, #FFFFFF 50%, #FFFFFF 100%)`,
					}}
				/>
				<div
					className="absolute top-0 bottom-0 right-[200px] w-[2px]"
					style={{
						background: `linear-gradient(to left, #BFA99F 0%, #BFA99F 50%, #FFFFFF 50%, #FFFFFF 100%)`,
					}}
				/>
			</div>

			{/* Left container (holds TOC and inner right-edge border) */}
			<div className="relative row-start-2 col-start-1 hidden lg:flex flex-col p-2">
				<div className="fixed hidden lg:flex items-start justify-start z-20">
					<TableOfContents
						content={[markdownContent]}
						pageName="About"
						accentColor={ABOUT_ACCENT}
						homeOnly={false}
						darkMode={false}
						inline
					/>
				</div>
			</div>

			{/* Right container (empty, with inner left-edge border) */}
			<div className="relative hidden lg:block row-start-2 col-start-3"></div>

			{/* Center content */}
			<div className="row-start-2 col-start-1 lg:col-start-2 flex flex-col w-full min-w-0 items-center gap-y-8 px-5 sm:px-8 lg:px-14 pt-16 lg:pt-0 bg-white overflow-x-hidden shadow-[0_0_12px_rgba(0,0,0,0.15)]">
				{/* Header Container */}
				<div className="flex flex-col w-full max-w-[1000px] h-fit justify-center items-center mt-0 lg:mt-[30px] gap-2 bg-[#113b1b] text-white p-4 rounded-2xl border-[#B7B3B0] bg-gradient-to-b from-white/20 via-white/50 to-white/80 shadow-[0_0_0_1px_rgba(0,0,0,0.08),0_-2px_1px_0_rgba(0,0,0,0.08)_inset,0_2px_1px_0_rgba(255,255,255,0.5)_inset,0_2px_5px_-1px_rgba(0,0,0,0.05),0_1px_3px_-1px_rgba(0,0,0,0.3)]">
					<h1 className="text-center text-6xl font-semibold tracking-[-0.04em]">
						About
					</h1>
					<img
						src={aboutImage}
						alt="hero"
						className="object-contain max-h-[300px] rounded-2xl my-2"
					/>
				</div>
				<div className="body w-full max-w-[1000px] min-w-0 p-4 rounded-3xl overflow-hidden">
					<MarkdownRenderer
						markdown={markdownContent}
						images={images}
						className="about-content w-full max-w-full min-w-0 overflow-hidden"
					/>
				</div>
				{/* Close center content wrapper */}
			</div>

			{/* Bottom container (mirror of top border line) */}
			<div className="relative col-span-3 row-start-3 h-[30px] pointer-events-none z-20">
				<div
					className="absolute top-0 left-0 right-0 h-[2px] z-20"
					style={{
						background: `linear-gradient(to bottom, #FFFFFF 0%, #FFFFFF 50%, #BFA99F 50%, #BFA99F 100%)`,
					}}
				/>
			</div>
		</div>
	);
};

export default About;
